import React from 'react'
import gql from 'graphql-tag'
import { useQuery, useMutation } from 'react-apollo'
import { createContext } from 'labguard-cdk'

const query = gql`
  query account {
    account {
      id
      locale {
        id
      }
      lang {
        id
      }
    }
  }
`

const logoutMutation = gql`
  mutation logout {
    logout
  }
`

const loginMutation = gql`
  mutation login($username: String!, $password: String!, $database: ID) {
    login(username: $username, password: $password, database: $database)
  }
`

const options = {
  refetchQueries: [{ query }],
  awaitRefetchQueries: true,
  context: {
    notify: { error: true, loading: false, success: false },
  },
  // Clear the entire cache after login or logout to force refetch of global app permissions and avoid inconsistencies
  update: cache => cache.clear(),
}

/**
 * Creates a context for url query parameters management
 */
export default createContext(
  Provider =>
    function AccountContext(props) {
      const { data: { account = {} } = {}, refetch } = useQuery(query)

      const [logout] = useMutation(logoutMutation, options)

      const [login] = useMutation(loginMutation, options)

      return <Provider {...props} value={{ account, refetch, logout, login }} />
    }
)
